// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ItemId = (tag, _1) => ({tag, _1});
const ProductItemIsSymbol = {reflectSymbol: () => "ProductItem"};
const ComboItemIsSymbol = {reflectSymbol: () => "ComboItem"};
const decodeSingleConstructorAr1 = {unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)};
const genericEncodeArgsArgument = {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)};
const genericDecodeArgsArgument = {
  decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
  decodeSingleRecordArg: Data$dMaybe.Nothing
};
const ProductItem = value0 => $ItemId("ProductItem", value0);
const ComboItem = value0 => $ItemId("ComboItem", value0);
const toFillFormTypeItemId = {fillFormDataType: v => "unknown"};
const eqItemId = {
  eq: x => y => {
    if (x.tag === "ProductItem") {
      if (y.tag === "ProductItem") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ComboItem") {
      if (y.tag === "ComboItem") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const ordItemId = {
  compare: x => y => {
    if (x.tag === "ProductItem") {
      if (y.tag === "ProductItem") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ProductItem") { return Data$dOrdering.GT; }
    if (x.tag === "ComboItem") {
      if (y.tag === "ComboItem") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqItemId
};
const genericItemId = {
  to: x => {
    if (x.tag === "Inl") { return $ItemId("ProductItem", x._1); }
    if (x.tag === "Inr") { return $ItemId("ComboItem", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ProductItem") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "ComboItem") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showItemId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})(ProductItemIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})(ComboItemIsSymbol);
    return x => {
      if (x.tag === "ProductItem") { return $0["genericShow'"](x._1); }
      if (x.tag === "ComboItem") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeItemId = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ProductItemIsSymbol)(decodeSingleConstructorAr1))(Unscramble$dGeneric.genericDecodeSumConstruct(ComboItemIsSymbol)(decodeSingleConstructorAr1)))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $ItemId("ProductItem", $1._1); }
      if ($1.tag === "Inr") { return $ItemId("ComboItem", $1._1); }
      $runtime.fail();
    };
  })()
};
const ufromJSONKeyItemId = /* #__PURE__ */ (() => ({fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", unscrambleDecodeItemId.unsafeDecode)}))();
const encodeItemId = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericItemId)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductItemIsSymbol)(genericEncodeArgsArgument);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(ComboItemIsSymbol)(genericEncodeArgsArgument);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const decodeItemId = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericItemId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductItemIsSymbol)(genericDecodeArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ComboItemIsSymbol)(genericDecodeArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))
};
const asJSONKeyItemId = /* #__PURE__ */ (() => ({asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction("AsJSONKeyValue", encodeItemId.encode, decodeItemId.decode)}))();
export {
  $ItemId,
  ComboItem,
  ComboItemIsSymbol,
  ProductItem,
  ProductItemIsSymbol,
  asJSONKeyItemId,
  decodeItemId,
  decodeSingleConstructorAr1,
  encodeItemId,
  eqItemId,
  genericDecodeArgsArgument,
  genericEncodeArgsArgument,
  genericItemId,
  ordItemId,
  showItemId,
  toFillFormTypeItemId,
  ufromJSONKeyItemId,
  unscrambleDecodeItemId
};
